module.exports = __webpack_public_path__ + "static/media/misc_event.b46916e6.png";